import React from 'react';
import { useLang } from '../LangContext';
import { useWeb3 } from '../Web3Context';
import { platforms } from '../data';

export default function Footer() {
  const { t } = useLang();
  const { wallet, displayName, isProHolder } = useWeb3();

  return (
    <footer style={{
      borderTop: '1px solid rgba(255,255,255,0.06)',
      padding: '3rem 1.5rem 2rem',
      background: 'var(--bg)',
    }}>
      <div style={{ maxWidth: '1000px', margin: '0 auto' }}>
        <div style={{
          display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))',
          gap: '2rem', marginBottom: '3rem',
        }}>
          {/* Brand */}
          <div>
            <div style={{
              fontFamily: 'var(--font-display)', fontWeight: 800, fontSize: '22px',
              color: 'var(--text)', marginBottom: '0.75rem', letterSpacing: '-0.02em',
            }}>
              Grab<span style={{ color: 'var(--brand)' }}>Watch</span><span style={{ color: 'var(--brand)' }}>.</span>
            </div>
            <p style={{ fontSize: '13px', color: 'var(--text3)', fontWeight: 300, lineHeight: 1.6, maxWidth: '220px', marginBottom: '1rem' }}>
              {t.footer.tagline}
            </p>

            {/* Wallet status in footer */}
            {wallet ? (
              <div style={{
                display: 'inline-flex', alignItems: 'center', gap: '6px',
                background: isProHolder ? 'rgba(108,71,255,0.1)' : 'rgba(255,255,255,0.04)',
                border: `1px solid ${isProHolder ? 'rgba(108,71,255,0.25)' : 'rgba(255,255,255,0.08)'}`,
                borderRadius: '99px', padding: '4px 12px', marginBottom: '1rem',
              }}>
                <div style={{ width: '6px', height: '6px', borderRadius: '50%', background: isProHolder ? '#A855F7' : '#22c55e' }} />
                <span style={{ fontSize: '11px', color: isProHolder ? '#A855F7' : 'var(--text2)', fontWeight: 500 }}>
                  {isProHolder ? '✦ Pro' : ''} {displayName}
                </span>
              </div>
            ) : null}

            <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
              {platforms.slice(1).map((p) => (
                <div key={p.id} title={p.name} style={{
                  width: '26px', height: '26px', borderRadius: '7px',
                  background: p.gradientBg || p.color,
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  cursor: 'pointer', transition: 'opacity 0.15s', opacity: 0.65,
                }}
                  onMouseEnter={e => e.currentTarget.style.opacity = '1'}
                  onMouseLeave={e => e.currentTarget.style.opacity = '0.65'}
                >{p.icon}</div>
              ))}
            </div>
          </div>

          {/* Link columns */}
          {t.footer.columns.map((col) => (
            <div key={col.title}>
              <h4 style={{
                fontFamily: 'var(--font-display)', fontSize: '12px', fontWeight: 700,
                color: 'var(--text)', letterSpacing: '0.06em', textTransform: 'uppercase', marginBottom: '1rem',
              }}>{col.title}</h4>
              <ul style={{ listStyle: 'none', display: 'flex', flexDirection: 'column', gap: '8px' }}>
                {col.links.map((link) => (
                  <li key={link}>
                    <a href="#" style={{ fontSize: '13px', color: 'var(--text3)', textDecoration: 'none', fontWeight: 300, transition: 'color 0.15s' }}
                      onMouseEnter={e => e.currentTarget.style.color = 'var(--text2)'}
                      onMouseLeave={e => e.currentTarget.style.color = 'var(--text3)'}
                    >{link}</a>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          {/* Web3 column */}
          <div>
            <h4 style={{
              fontFamily: 'var(--font-display)', fontSize: '12px', fontWeight: 700,
              color: 'var(--text)', letterSpacing: '0.06em', textTransform: 'uppercase', marginBottom: '1rem',
            }}>Web3</h4>
            <ul style={{ listStyle: 'none', display: 'flex', flexDirection: 'column', gap: '8px' }}>
              {['NFT Collection', 'Smart Contract', 'DAO Governance', 'Token Rewards', 'Opensea'].map((link) => (
                <li key={link}>
                  <a href="#" style={{ fontSize: '13px', color: 'var(--text3)', textDecoration: 'none', fontWeight: 300, transition: 'color 0.15s', display: 'flex', alignItems: 'center', gap: '5px' }}
                    onMouseEnter={e => e.currentTarget.style.color = '#A855F7'}
                    onMouseLeave={e => e.currentTarget.style.color = 'var(--text3)'}
                  >
                    {link}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* SEO-rich bottom: hreflang hint + copyright */}
        <div style={{
          borderTop: '1px solid rgba(255,255,255,0.05)',
          paddingTop: '1.5rem',
          display: 'flex', alignItems: 'center', justifyContent: 'space-between',
          flexWrap: 'wrap', gap: '12px',
        }}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
            <p style={{ fontSize: '12px', color: 'var(--text3)' }}>{t.footer.copyright}</p>
            <p style={{ fontSize: '11px', color: 'var(--text3)', opacity: 0.6 }}>
              youtube-downloader · instagram-downloader · tiktok-no-watermark · facebook-video-download
            </p>
          </div>
          <div style={{ display: 'flex', gap: '1.5rem', alignItems: 'center' }}>
            {/* Schema.org microdata visual hint */}
            <span style={{ fontSize: '11px', color: 'var(--text3)', display: 'flex', alignItems: 'center', gap: '4px' }}>
              <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="20 6 9 17 4 12"/></svg>
              Schema.org ✓
            </span>
            <span style={{ fontSize: '11px', color: 'var(--text3)', display: 'flex', alignItems: 'center', gap: '4px' }}>
              <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="20 6 9 17 4 12"/></svg>
              Open Graph ✓
            </span>
            {t.footer.legal.map((item) => (
              <a key={item} href="#" style={{ fontSize: '12px', color: 'var(--text3)', textDecoration: 'none', transition: 'color 0.15s' }}
                onMouseEnter={e => e.currentTarget.style.color = 'var(--text2)'}
                onMouseLeave={e => e.currentTarget.style.color = 'var(--text3)'}
              >{item}</a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
